import licensesClient from '@/api/licenses.js'

// initial state
const state = {
  licenses: [],
  // Track pks from the lite endpoint, loaded at login so track lists can mark licensed
  // tracks. Kept apart from `licenses` so the full list LicenseList renders is never
  // replaced by these stripped-down records if the two requests race.
  licensedTrackPks: []
}

// getters
const getters = {
  licenses (state) {
    return state.licenses
  },

  isLicensed: state => trackPk => {
    return state.licensedTrackPks.includes(trackPk) ||
      state.licenses.some(license => license.track.pk === trackPk)
  }
}

// actions
const actions = {
  fetchLicenses: (context) => {
    return licensesClient.listAll()
      .then((data) => {
        context.commit(SET_LICENSES, data)
        return data
      })
  },

  fetchLicensesLite: (context) => {
    return licensesClient.liteAll()
      .then((data) => {
        // The lite API gives each license's track as a pk.
        context.commit(SET_LICENSED_TRACK_PKS, data.map(license => license.track))
      })
  },

  clearLicenses: (context) => {
    context.commit(SET_LICENSES, [])
    context.commit(SET_LICENSED_TRACK_PKS, [])
  }
}

// mutations
const SET_LICENSES = 'SET_LICENSES'
const SET_LICENSED_TRACK_PKS = 'SET_LICENSED_TRACK_PKS'

const mutations = {
  [SET_LICENSES]: (state, payload) => {
    state.licenses = payload
  },

  [SET_LICENSED_TRACK_PKS]: (state, payload) => {
    state.licensedTrackPks = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
